import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { editDetailPage } from '../../../pages/_redux/actions/inboxActions';
import { PostMessageLogout, recordSetSearch } from '../../api/api';
import {
    formatNameWithSpaceToUnderscore,
    formatDate,
    GetFieldData,
    EpisodeSearch,
    loadHTMLData,
    formatHeaderNameWithOutSpace,
    OrderWithUnderScore,
    encodeParameter,
} from '../../../components/commonfunction';
import * as moment from 'moment-timezone';
import PropTypes from 'prop-types';

const ViewDetails = (props) => {
    // State
    const [allRecordSetID, setAllRecordSetId] = useState(null);
    const [allFieldId, setAllFieldId] = useState(null);
    const [rowDetails, setRowDetails] = useState({});
    const [rowValues, setRowValues] = useState({});
    const [currentLookup, setCurrentLookup] = useState('');
    const [episodeVisitData, setEpisodeVisitData] = useState([]);

    // Global State
    const dispatch = useDispatch();
    const reduxConfigData = useSelector(
        (state) => state.configReducerPersist.configData
    );
    const selectedRowDetails = useSelector(
        (state) => state.inbox.selectedRowDetails
    );
    const configuredRecordsets = useSelector(
        (state) => state.configReducerPersist.configuredRecordsets
    );

    // Lifecycle
    useEffect(() => {
        const initializeViewDetailsAsync = async () => {
            try {
                await initializeViewDetails();
            } catch (error) {
                console.error('Error initializing view details:', error);
            }
        };
        initializeViewDetailsAsync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRowDetails, props.selectedDocId]);

    // Methods
    const initializeViewDetails = async () => {
        if (!reduxConfigData) return;

        let fieldData = GetFieldData({ configData: reduxConfigData });
        setAllFieldId(fieldData);

        var allRecordSetID = {};
        let episodeRecordsetId;
        let orderRecordsetId;

        if (configuredRecordsets) {
            configuredRecordsets.forEach((data) => {
                if (formatHeaderNameWithOutSpace(data.name) === 'episodedata') {
                    episodeRecordsetId = data.recordsetId;
                } else if (
                    formatHeaderNameWithOutSpace(data.name) === 'orderdata'
                ) {
                    orderRecordsetId = data.recordsetId;
                }

                var fieldIDArray = {};

                if (data.hasOwnProperty('fields') && data.fields.length > 0) {
                    data.fields.forEach((field) => {
                        fieldIDArray[
                            formatNameWithSpaceToUnderscore(field.name)
                        ] = field;
                    });
                    data.fields_obj = fieldIDArray;
                }
                var name = formatNameWithSpaceToUnderscore(data.name);
                allRecordSetID[name] = data;
            });
        }

        setAllRecordSetId(allRecordSetID);

        var rowDetails = [];
        var allFields = reduxConfigData.fields;

        if (selectedRowDetails.hasOwnProperty('fields')) {
            rowDetails = selectedRowDetails.fields;
        }

        var finalRowDetail = {};
        var formDataTemp = {};

        if (rowDetails.length > 0) {
            rowDetails.forEach((rowdetail) => {
                allFields.forEach((allfields) => {
                    var temp = { ...rowdetail };
                    if (rowdetail.fieldId === allfields.fieldId) {
                        temp.fieldName = allfields.name;
                        var removeSpace = formatNameWithSpaceToUnderscore(
                            allfields.name
                        );
                        finalRowDetail[removeSpace] = temp;
                    }
                });
            });
        }

        const transformedData = {};

        for (const key in finalRowDetail) {
            transformedData[key] = finalRowDetail[key].value;
        }

        setRowDetails(finalRowDetail);
        setRowValues(transformedData);

        if (
            rowDetails.hasOwnProperty('patient_name') &&
            rowDetails.patient_name.value !== ''
        ) {
            let split = rowDetails.patient_name.value.split(',');
            rowDetails.patient_name.value = split[0] + ', ' + split[1];
        }

        var patient_filter = {};

        const setOfValidValues = [
            'branch',
            'date_of_birth',
            'service_line',
            'patient_name',
            'gender',
            'patient_id',
            'order_number',
            'order_date',
        ];

        const anotherArrayOfValidValues = [
            'attachment_type',
            'attachment_location',
            'team',
            'comments',
            'new_referral',
            'date_of_birth_validation',
            'signed_date',
            'payor_source',
            'care_type',
            'episodeid',
            'referral_date',
        ];

        for (const value in rowDetails) {
            if (setOfValidValues.includes(value)) {
                var key = formatNameWithSpaceToUnderscore(
                    rowDetails[value].fieldName
                );
                patient_filter[key] = rowDetails[value].value;
            }
            if (anotherArrayOfValidValues.includes(value)) {
                var formKey = formatNameWithSpaceToUnderscore(
                    rowDetails[value].fieldName
                );
                formDataTemp[formKey] = rowDetails[value].value;
            }
        }

        let selectRowDetail = selectedRowDetails.fields;
        let configData = reduxConfigData.fields;
        let visitShow = false;

        await selectRowDetail.forEach((data) => {
            if (allFieldId) {
                if (data.fieldId === allFieldId.visit_id) {
                    visitShow = true;
                }
            }
        });

        let fieldObj = {};
        configData.forEach((item) => {
            if (item.name === 'AgencyID') {
                fieldObj.agencyid = item.fieldId;
            }
            if (item.name === 'EpisodeID') {
                fieldObj.episodeId = item.fieldId;
            }
        });

        const fieldObj2 = selectRowDetail.reduce((pre, curr) => {
            if (curr.fieldId === fieldObj.agencyid) {
                pre.agency_value = curr.value;
            }
            if (curr.fieldId === fieldObj.episodeId) {
                pre.episode_value = curr.value;
            }
            return pre;
        }, {});

        if (
            visitShow === true &&
            fieldObj2.agency_value &&
            fieldObj2.episode_value
        ) {
            let episodeSearch = `fieldSearch=${fieldObj.agencyid}=${fieldObj2.agency_value}&fieldSearch=${fieldObj.episodeId}=${fieldObj2.episode_value}`;
            episodeVisitFunction(episodeSearch);
        }

        if (typeof props.updateState === 'function') {
            props.updateState();
        }

        if (
            patient_filter.hasOwnProperty('patient_name') &&
            patient_filter.patient_name !== ''
        ) {
            let split = patient_filter.patient_name.trim().split(',');
            patient_filter.last_name = split[0];
            patient_filter.first_name = split[1];
        }

        if (rowDetails.hasOwnProperty('order_number')) {
            if (typeof props.updateState === 'function') {
                patient_filter.fromViewDetail = true;
                patient_filter.id = '-123';
                if (props.updateState) {
                    props.updateState({
                        currentLookup: 'byOrder',
                        patient_filter: patient_filter,
                    });
                }
            }
            setCurrentLookup('byOrder');
        } else {
            if (typeof props.updateState === 'function') {
                if (!patient_filter) {
                    patient_filter.id = '-123';
                    patient_filter.patientRecord = true;
                }
                setCurrentLookup('byPatient');
                if (props.updateState) {
                    props.updateState({
                        currentLookup: 'byPatient',
                        patient_filter: patient_filter,
                    });
                }
            }
        }

        if (typeof props.updateState === 'function') {
            props.updateState({
                fromViewDetails: true,
                formData: formDataTemp,
            });
        }

        if (props.callingFrom !== 'global_actions') {
            dispatch(editDetailPage({ viewDetailFormdata: formDataTemp }));
        }

        if (
            rowDetails?.attachment_location?.value === 'EPISODE' &&
            rowValues.order_number
        ) {
            orderApiCall(episodeRecordsetId, orderRecordsetId);
        }
    };

    const orderApiCall = async (episodeRecordsetId, orderRecordsetId) => {
        try {
            const orderSearchText = reduxConfigData.fields.find(
                (field) => field.name === 'Order Number'
            )?.fieldId
                ? `fieldSearch=${
                      reduxConfigData.fields.find(
                          (field) => field.name === 'Order Number'
                      ).fieldId
                  }%3D${rowValues.order_number}%2A`
                : null;

            if (!orderSearchText) {
                throw new Error('Order Number field not found');
            }

            const resultOrder = await recordSetSearch(
                orderRecordsetId,
                orderSearchText
            );
            if (resultOrder.status !== 200) {
                throw new Error('Error in recordSetSearch');
            }

            const orderData = await resultOrder.json();
            if (orderData?.code === 300) {
                PostMessageLogout();
                return;
            }

            if (orderData) {
                const searchResult = OrderWithUnderScore(orderData);
                if (searchResult.length === 1) {
                    const episodeid = searchResult[0].episodeid;
                    await episodeApiCall(episodeRecordsetId, episodeid);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const episodeApiCall = async (episodeRecordsetId, episodeid) => {
        let searchText = '';

        const inputSearchfields =
            allRecordSetID?.episode_data?.inputSearchFieldIds || [];

        inputSearchfields.forEach((input, index) => {
            let amb = index === 0 ? '' : '&';
            const fieldMapping = {
                [allFieldId.agencyid]: rowValues.agencyid,
                [allFieldId.branch]: encodeParameter(rowValues.branch),
                [allFieldId.patient_id]: rowValues.patient_id,
            };

            if (fieldMapping[input]) {
                searchText += `${amb}fieldSearch=${input}=${fieldMapping[input]}`;
            }
        });

        if (episodeid) {
            searchText += `&fieldSearch=${allFieldId.episodeid}=${episodeid}`;
        }

        try {
            const result = await recordSetSearch(
                episodeRecordsetId,
                searchText
            );

            if (result.status !== 200) {
                throw new Error('Error in recordSetSearch');
            }

            const data = await result.json();

            if (data?.code === 300) {
                PostMessageLogout();
                return;
            }

            if (data) {
                const searchResult = EpisodeSearch(data);

                if (searchResult.length === 1) {
                    const episodeData = searchResult[0];
                    const updateData = {
                        select_an_episode: episodeData.select_an_episode || '',
                        episode_end: episodeData.episode_end || '',
                        episode_start: episodeData.episode_start || '',
                        episode_status: episodeData.episode_status || '',
                        medical_record_: episodeData.medical_record_ || '',
                    };

                    setRowDetails((prevDetails) => ({
                        ...prevDetails,
                        ...updateData,
                    }));

                    setRowValues((prevValues) => ({
                        ...prevValues,
                        ...updateData,
                    }));
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const episodeVisitFunction = async (searchText) => {
        try {
            const response = await recordSetSearch(
                allRecordSetID.episode_visit_data.recordsetId,
                searchText
            );

            if (response.status !== 200) {
                throw new Error('Error in recordSetSearch');
            }

            const data = await response.json();

            if (data?.code === 300) {
                PostMessageLogout();
                return;
            }

            const searchResult = EpisodeSearch(data);

            if (searchResult.length === 1) {
                const formDataObject = {
                    episode_visit: searchResult[0].visit_date,
                };
                if (props.updateState) {
                    props.updateState({ formDataObject });
                }
            }

            setEpisodeVisitData(searchResult);
        } catch (error) {
            console.error(error);
        }
    };

    // JSX

    return (
        <div>
            {[
                'order_number',
                'order_date',
                'mr',
                'patient_name',
                'date_of_birth',
                'gender',
                'new_referral',
                'attachment_type',
                'attachment_location',
                'signed_date',
                'date_of_birth_validation',
                'episodeid',
                'episode_status',
                'episode_start',
                'episode_end',
                'select_an_episode',
                'branch',
                'visit_date',
                'comments',
            ].every((key) => !rowDetails.hasOwnProperty(key)) && (
                <div className='no_detail'>
                    No details added yet. Click on the “Edit Details” button
                    above to get started.
                </div>
            )}

            {rowDetails.hasOwnProperty('branch') &&
                Object.keys(rowDetails).length === 2 && (
                    <div className='no_detail'>No details found.</div>
                )}

            {rowDetails.new_referral && (
                <div style={{ display: 'flex' }} className='form-group row'>
                    <div className='col-lg-4 transition-select'>
                        <span className='view_details_patient_label'>
                            NEW REFERRAL?
                        </span>
                        <span className='patient_info'>
                            {rowDetails.new_referral.value || '-'}
                        </span>
                    </div>
                </div>
            )}

            {currentLookup === 'byOrder' ? (
                <>
                    {[
                        'order_number',
                        'order_date',
                        'mr',
                        'patient_name',
                        'date_of_birth',
                        'gender',
                    ].every((key) => rowDetails.hasOwnProperty(key)) && (
                        <div
                            className='patient_detail edit-detail-bg'
                            style={{ backgroundColor: '#F0F7FB' }}
                        >
                            <div
                                style={{ display: 'flex' }}
                                className='form-group row'
                            >
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        ORDER NUMBER
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.order_number
                                            ? `# ${rowDetails.order_number.value}`
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4'>
                                    <span className='view_details_patient_label'>
                                        ORDER DATE
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.order_date
                                            ? formatDate(
                                                  rowDetails.order_date.value,
                                                  'MM/DD/YYYY'
                                              )
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        MR #
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.mr
                                            ? rowDetails.mr.value
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        PATIENT NAME
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.patient_name.value
                                            ? rowDetails.patient_name.value
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        DATE OF BIRTH
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.date_of_birth
                                            ? formatDate(
                                                  rowDetails.date_of_birth
                                                      .value,
                                                  'MM/DD/YYYY'
                                              )
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        GENDER
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.gender
                                            ? rowDetails.gender.value
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        BRANCH
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.branch
                                            ? rowDetails.branch.value
                                            : ' - '}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <>
                    {!['patient_name', 'date_of_birth', 'gender'].every(
                        (key) => !rowDetails.hasOwnProperty(key)
                    ) && (
                        <div
                            className='patient_detail edit-detail-bg'
                            style={{ backgroundColor: '#F0F7FB' }}
                        >
                            <div
                                style={{ display: 'flex' }}
                                className='form-group row'
                            >
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        PATIENT NAME
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.patient_name?.value
                                            ? rowDetails.patient_name.value
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        DATE OF BIRTH
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.date_of_birth?.value
                                            ? formatDate(
                                                  rowDetails.date_of_birth
                                                      .value,
                                                  'MM/DD/YYYY'
                                              )
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        GENDER
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.gender?.value
                                            ? rowDetails.gender.value
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        SERVICE LINE
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.service_line?.value
                                            ? rowDetails.service_line.value
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='col-lg-4 transition-select'>
                                    <span className='view_details_patient_label'>
                                        BRANCH
                                    </span>
                                    <span className='patient_info'>
                                        {rowDetails.branch?.value
                                            ? rowDetails.branch.value
                                            : ' - '}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            {['payor_source', 'care_type', 'team', 'referral_date'].every(
                (key) => rowDetails.hasOwnProperty(key)
            ) && (
                <div
                    className='patient_detail edit-detail-bg'
                    style={{ backgroundColor: '#F0F7FB', marginTop: '20px' }}
                >
                    <div className='form-group row'>
                        {reduxConfigData.indexingSettings.payorSourceUsed && (
                            <div className='col-lg-4 transition-select'>
                                <span className='view_details_patient_label'>
                                    PAYOR SOURCE
                                </span>
                                <span className='patient_info'>
                                    {rowDetails.payor_source?.value || ' - '}
                                </span>
                            </div>
                        )}
                        {reduxConfigData.indexingSettings.careTypeUsed && (
                            <div className='col-lg-4 transition-select'>
                                <span className='view_details_patient_label'>
                                    CARE TYPE
                                </span>
                                <span className='patient_info'>
                                    {rowDetails.care_type?.value || ' - '}
                                </span>
                            </div>
                        )}
                        {reduxConfigData.indexingSettings.teamUsed && (
                            <div className='col-lg-4 transition-select'>
                                <span className='view_details_patient_label'>
                                    TEAM
                                </span>
                                <span className='patient_info'>
                                    {rowDetails.team?.value || ' - '}
                                </span>
                            </div>
                        )}
                        <div className='col-lg-4 transition-select'>
                            <span className='view_details_patient_label'>
                                REFERRAL DATE
                            </span>
                            <span className='patient_info'>
                                {rowDetails.referral_date?.value
                                    ? moment(
                                          new Date(
                                              rowDetails.referral_date.value
                                          )
                                      ).format('MM/DD/y')
                                    : ' - '}
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {['signed_date', 'date_of_birth_validation'].every((key) =>
                rowDetails.hasOwnProperty(key)
            ) && (
                <div className='form-group patient_detail row'>
                    <div className='col-lg-6'>
                        <span className='view_details_patient_label'>
                            DATE OF BIRTH VALIDATION
                        </span>
                        <span className='patient_info'>
                            {rowDetails.date_of_birth_validation?.value
                                ? formatDate(
                                      rowDetails.date_of_birth_validation.value,
                                      'MM/DD/YYYY'
                                  )
                                : ' - '}
                        </span>
                    </div>
                    <div className='col-lg-6 transition-select'>
                        <span className='view_details_patient_label'>
                            SIGNED DATE
                        </span>
                        <span className='patient_info'>
                            {rowDetails.signed_date?.value
                                ? formatDate(
                                      rowDetails.signed_date.value,
                                      'MM/DD/YYYY'
                                  )
                                : ' - '}
                        </span>
                    </div>
                </div>
            )}

            <div className='form-group patient_detail row'>
                {rowDetails.attachment_type && (
                    <div className='col-lg-6 transition-select'>
                        <span className='view_details_patient_label'>
                            {reduxConfigData.indexingSettings.attachmentTypeLabel?.toUpperCase() ||
                                'ATTACHMENT TYPE'}
                        </span>
                        <span className='patient_info'>
                            {rowDetails.attachment_type.value || ' - '}
                        </span>
                    </div>
                )}
                {reduxConfigData.indexingSettings.locationUsed &&
                    rowDetails.attachment_location && (
                        <div className='col-lg-6 transition-select'>
                            <span className='view_details_patient_label'>
                                {reduxConfigData.indexingSettings.locationLabel?.toUpperCase() ||
                                    'ATTACHMENT LOCATION'}
                            </span>
                            <span className='patient_info'>
                                {rowDetails.attachment_location.value || ' - '}
                            </span>
                        </div>
                    )}
                {rowValues.select_an_episode &&
                    ['episode', 'visit'].some((term) =>
                        rowDetails?.attachment_location?.value
                            ?.toLowerCase()
                            .includes(term)
                    ) && (
                        <div className='col-lg-6 transition-select'>
                            <span className='view_details_patient_label'>
                                EPISODE
                            </span>
                            <span className='patient_info'>
                                {rowDetails.select_an_episode?.value || ' - '}
                            </span>
                        </div>
                    )}
                {rowDetails.visit_id && (
                    <div className='col-lg-6 transition-select'>
                        <span className='view_details_patient_label'>
                            EPISODE VISIT
                        </span>
                        <span className='patient_info'>
                            {episodeVisitData?.find(
                                (item) =>
                                    item.visit_id === rowDetails.visit_id.value
                            )?.visit_label || ' - '}
                        </span>
                    </div>
                )}
            </div>

            {rowValues.select_an_episode &&
            ['episode', 'visit'].every((term) =>
                rowDetails?.attachment_location?.value
                    ?.toLowerCase()
                    .includes(term)
            ) ? (
                <div
                    className='patient_detail edit-detail-bg'
                    style={{ backgroundColor: '#F0F7FB', marginTop: '20px' }}
                >
                    <div className='form-group row'>
                        <div className='col-lg-4 transition-select'>
                            <span className='view_details_patient_label'>
                                EPISODE STATUS
                            </span>
                            <span className='patient_info'>
                                {rowDetails.episode_status?.value || '-'}
                            </span>
                        </div>
                        <div className='col-lg-4 transition-select'>
                            <span className='view_details_patient_label'>
                                START DATE
                            </span>
                            <span className='patient_info'>
                                {rowDetails.episode_start?.value
                                    ? formatDate(
                                          rowDetails.episode_start.value,
                                          'MM/DD/YYYY'
                                      )
                                    : '-'}
                            </span>
                        </div>
                        <div className='col-lg-4 transition-select'>
                            <span className='view_details_patient_label'>
                                END DATE
                            </span>
                            <span className='patient_info'>
                                {rowDetails.episode_end?.value
                                    ? formatDate(
                                          rowDetails.episode_end.value,
                                          'MM/DD/YYYY'
                                      )
                                    : '-'}
                            </span>
                        </div>
                    </div>
                    <div
                        style={{ display: 'flex' }}
                        className='form-group row mb-0'
                    >
                        <div className='col-lg-4 transition-select'>
                            <span className='view_details_patient_label'>
                                BRANCH
                            </span>
                            <span className='patient_info'>
                                {rowDetails.branch?.value || '-'}
                            </span>
                        </div>
                    </div>
                </div>
            ) : null}

            {rowDetails.comments && (
                <div className='form-group patient_detail row'>
                    <div className='col-lg-12'>
                        <span className='view_details_patient_label'>
                            COMMENTS
                        </span>
                        <span
                            className='patient_info'
                            id='view_comments2'
                            dangerouslySetInnerHTML={loadHTMLData(
                                rowDetails.comments.value
                            )}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

// Props
ViewDetails.propTypes = {
    updateState: PropTypes.func,
    callingFrom: PropTypes.string,
};

export default ViewDetails;
